import React from "react";
import LegalPage from "./LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy">
      <p><strong>Last updated:</strong> September 7, 2026</p>

      <p>
        Wellora AI provides customer relationship management, appointment
        scheduling, communication, automation and AI-assisted support tools
        for wellness, aesthetics and beauty businesses.
      </p>

      <h3>Information we collect</h3>
      <p>
        Depending on how Wellora AI is used, we may process information such as
        names, phone numbers, WhatsApp numbers, email addresses, appointment
        information, service interests, conversation content, lead details and
        related customer-service records.
      </p>

      <h3>How we use information</h3>
      <p>
        Information is used to manage customer enquiries, maintain CRM records,
        schedule and manage appointments, provide customer support, send
        permitted service communications, improve workflows and operate
        AI-assisted responses.
      </p>

      <h3>WhatsApp and Meta services</h3>
      <p>
        When WhatsApp Business Platform features are enabled, message and account
        information may be processed through Meta's WhatsApp Business services
        in accordance with Meta's applicable terms and policies.
      </p>

      <h3>Data sharing</h3>
      <p>
        We do not sell personal information. Information may be shared with
        service providers and technology platforms only where required to
        provide, secure or operate Wellora AI and its connected services.
      </p>

      <h3>Data retention and security</h3>
      <p>
        We retain information only for as long as reasonably required for the
        purposes described above, subject to contractual and legal obligations.
        Appropriate technical and organizational safeguards are used to protect
        information from unauthorized access, loss or misuse.
      </p>

      <h3>Your choices and rights</h3>
      <p>
        Users may request access, correction or deletion of eligible personal
        information, subject to applicable law and legitimate retention
        requirements.
      </p>

      <h3>Contact</h3>
      <p>
        For privacy-related questions or requests, contact the Wellora AI
        administrator through the contact details provided by the organization
        using the platform.
      </p>
    </LegalPage>
  );
}
